module.exports = __webpack_public_path__ + "static/img/视频回放.f3cf8c7.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/视频回放.svg
// module id = gVBy
// module chunks = 1